import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row card rounded-0" }
const _hoisted_2 = { class: "col-12 card-header" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12 col-md-8" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "pb-0 mb-0" }
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { class: "text-primary" }
const _hoisted_9 = { class: "col-sm-12 col-md-4 text-end" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 0,
  class: "card mb-4 shadow-sm w-100"
}
const _hoisted_16 = { class: "card-header bg-secondary text-white fw-bold" }
const _hoisted_17 = { class: "card-body" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "radio-custom" }
const _hoisted_21 = ["id", "name", "value", "onClick"]
const _hoisted_22 = { key: 1 }
const _hoisted_23 = {
  class: "btn-group btn-group-toggle float-end mb-3",
  "data-toggle": "buttons"
}
const _hoisted_24 = ["for"]
const _hoisted_25 = ["id", "name", "value"]
const _hoisted_26 = { key: 2 }
const _hoisted_27 = ["name", "onInput"]
const _hoisted_28 = { key: 3 }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-6" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "col-6" }
const _hoisted_33 = {
  class: "btn-group btn-group-toggle float-end",
  "data-toggle": "buttons"
}
const _hoisted_34 = ["for"]
const _hoisted_35 = ["id", "name", "value"]
const _hoisted_36 = { class: "col-12 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_alert = _resolveComponent("error-alert")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "row card text-white rounded-0 top-header" }, [
        _createElementVNode("div", { class: "col-12 text-center" }, [
          _createElementVNode("h2", { class: "my-3 fw-bold" }, "SP Scorecard")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: _ctx.visit.scenario.patient_image.location,
                class: "rounded-circle float-start me-4",
                width: "100"
              }, null, 8, _hoisted_5),
              _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.visit.scenario.patient_name), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.visit.scenario.title), 1),
              _createElementVNode("p", _hoisted_8, "Visit was completed on " + _toDisplayString(_ctx.moment(_ctx.visit.utc_time || _ctx.visit.local_time).format('MM/DD/YY')) + " at " + _toDisplayString(_ctx.moment(_ctx.visit.utc_time || _ctx.visit.local_time).format('h:mma')), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                class: "btn btn-lg btn-secondary-alt w-75",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.returnToVisit && _ctx.returnToVisit(...args)))
              }, "Return to Visit")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              class: "col-12 px-5 py-4 text-center fw-bold",
              innerHTML: _ctx.visit.scenario.feedback_form.instructions
            }, null, 8, _hoisted_12),
            _cache[8] || (_cache[8] = _createElementVNode("hr", { class: "w-75" }, null, -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (question_set, key) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-12",
                key: key
              }, [
                (question_set.name !== null)
                  ? (_openBlock(), _createElementBlock("h3", {
                      key: 0,
                      innerHTML: question_set.name,
                      class: "col-12 text-center"
                    }, null, 8, _hoisted_13))
                  : _createCommentVNode("", true),
                (question_set.instructions !== null)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      innerHTML: question_set.instructions,
                      class: "col-12 px-5 pt-1 pb-4 text-center fw-bold"
                    }, null, 8, _hoisted_14))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(question_set.display_type == 1 ? 'row px-3' : 'card-columns px-3')
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question_set, (question, k) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(question_set.display_type == 1 ? 'col-12 col-md-6 col-lg-6' : ''),
                      key: k
                    }, [
                      (k !== 'instructions' && k !== 'name' && k !=='display_type')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, "Question " + _toDisplayString(parseInt(k) + 1), 1),
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("span", {
                                innerHTML: question.question
                              }, null, 8, _hoisted_18),
                              _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1)),
                              (question.question_type_id == _ctx.QuestionType.MULTIPLECHOICE)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answers, (answer) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: answer.id
                                      }, [
                                        _createElementVNode("label", _hoisted_20, [
                                          _createElementVNode("span", null, _toDisplayString(answer.answer), 1),
                                          _createElementVNode("input", {
                                            type: "radio",
                                            id: answer.id,
                                            name: question.id,
                                            value: answer.id,
                                            onClick: ($event: any) => (_ctx.clearError('error_'+question.id))
                                          }, null, 8, _hoisted_21),
                                          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "checkmark" }, null, -1))
                                        ])
                                      ]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true),
                              (question.question_type_id == _ctx.QuestionType.TRUEFALSE)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    _createElementVNode("div", _hoisted_23, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answers, (answer) => {
                                        return (_openBlock(), _createElementBlock("label", {
                                          key: answer.id,
                                          class: _normalizeClass('p-3 btn btn-light btn_ques_' + question.id),
                                          for: answer.id
                                        }, [
                                          _createElementVNode("input", {
                                            class: "btn-check",
                                            type: "radio",
                                            id: answer.id,
                                            name: question.id,
                                            value: answer.id,
                                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.buttonUpdate && _ctx.buttonUpdate(...args)))
                                          }, null, 8, _hoisted_25),
                                          _createTextVNode(_toDisplayString(answer.answer), 1)
                                        ], 10, _hoisted_24))
                                      }), 128))
                                    ]),
                                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "clearfix" }, null, -1))
                                  ]))
                                : _createCommentVNode("", true),
                              (question.question_type_id == _ctx.QuestionType.LONGFILL)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                    _createElementVNode("textarea", {
                                      class: "w-100",
                                      name: question.id,
                                      onInput: ($event: any) => (_ctx.clearError('error_'+question.id))
                                    }, null, 40, _hoisted_27)
                                  ]))
                                : _createCommentVNode("", true),
                              (question.question_type_id == _ctx.QuestionType.LIKERT)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                    _createElementVNode("div", _hoisted_29, [
                                      _createElementVNode("div", _hoisted_30, [
                                        _createElementVNode("small", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answers, (answer, index) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                              key: answer.id
                                            }, [
                                              _createTextVNode(_toDisplayString(index + 1) + " = " + _toDisplayString(answer.answer), 1),
                                              (index !== 4)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_31, ", "))
                                                : _createCommentVNode("", true)
                                            ]))
                                          }), 128))
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_32, [
                                        _createElementVNode("div", _hoisted_33, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answers, (answer, index) => {
                                            return (_openBlock(), _createElementBlock("label", {
                                              key: answer.id,
                                              class: _normalizeClass('p-3 btn btn-light btn_ques_' + question.id),
                                              for: 'ans_' + answer.id
                                            }, [
                                              _createElementVNode("input", {
                                                class: "btn-check",
                                                type: "radio",
                                                id: 'ans_' + answer.id,
                                                name: question.id,
                                                value: answer.id,
                                                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.buttonUpdate && _ctx.buttonUpdate(...args)))
                                              }, null, 8, _hoisted_35),
                                              _createTextVNode(_toDisplayString(index + 1), 1)
                                            ], 10, _hoisted_34))
                                          }), 128))
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_error_alert, {
                                elm_id: 'error_'+question.id
                              }, null, 8, ["elm_id"])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
                ], 2),
                _cache[7] || (_cache[7] = _createElementVNode("hr", { class: "w-75" }, null, -1))
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("button", {
                class: "btn btn-lg btn-primary my-4 px-5 fw-bold",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submitFeedbackForm && _ctx.submitFeedbackForm(...args)))
              }, "SUBMIT SP SCORECARD & MARK VISIT AS COMPLETE")
            ])
          ])
        ])
      ])
    ]),
    _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}